import React, {useState} from 'react';
import {config} from '../components/home/config';

const ConfigContext = React.createContext({
  selected: undefined,
});

export const ConfigContextProvider = ({children}) => {
  const [settings, setSettings] = useState(config);

  const onUpdate = (prop, value) => setSettings(state => ({...state, [prop]: value}));

  return (
    <ConfigContext.Provider value={{config: settings, onUpdate}}>{children}</ConfigContext.Provider>
  );
};

export default ConfigContext;
